import {Dispatch, ThunkAction} from '../../../../../../../types/actions';
import {boardImportBoardTrelloLearnMoreClickedSegmentEvent} from '../../../../../main/navigationPanel/effects/segmentEvents';

export const onClickTrelloLearnMore = (): ThunkAction => {
    const action = (dispatch: Dispatch) => {
        dispatch(boardImportBoardTrelloLearnMoreClickedSegmentEvent());
    };
    return action;
};
